<template>
    <div class="my-3">
        <h1 class="d-flex justify-center primary--text font-weight-light">Mes Posterior</h1>
        <v-card>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td>
                                    <v-icon left color="black">
                                        mdi-trophy-variant
                                    </v-icon>
                                    Cartera Base
                                </td>
                                <td>13.30 €</td>
                                <td>159.59 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left color="orange darken-2">
                                        mdi-trophy-variant
                                    </v-icon>
                                    Cartera Bronce
                                </td>
                                <td>22.17 €</td>
                                <td>265.98 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left color="grey lighten-1">
                                        mdi-trophy-variant
                                    </v-icon>
                                    Cartera Plata
                                </td>
                                <td>37.68 €</td>
                                <td>452.17 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left color="yellow darken-2">
                                        mdi-trophy-variant
                                    </v-icon>
                                    Cartera Oro
                                </td>
                                <td>48.76 €</td>
                                <td>585.16 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left color="grey darken-1">
                                        mdi-trophy-variant
                                    </v-icon>
                                    Cartera Platino
                                </td>
                                <td>48.76 €</td>
                                <td>585.16 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left color="red darken-4">
                                        mdi-trophy-variant
                                    </v-icon>
                                    Cartera TOP
                                </td>
                                <td>53.20 €</td>
                                <td>638.36 €</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'LowiNextMonth',
    data: () => ({

    }),
}
</script>
